import { z } from 'zod';
import { benefitCategories } from 'store/benefits';

export const benefitTemplatesFiltersSchema = z.object({
  category: z.array(z.enum(benefitCategories)).catch([]),
  countries: z.array(z.string()).catch([]),
  languages: z.array(z.string()).catch([]),
});
